(function() {
    'use strict';

    angular.module('swif.reservations')
    .config(route)
    .controller('ReservationKeysController', ReservationKeysController);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/reservations/keys/table_view', {
            templateUrl: 'partials/openbase/keys_table_view.html',
            controller: ReservationKeysController,
            controllerAs: '$ctrl',
            reloadOnSearch: false,
            resolve: {
                data: function(swifOpenbaseKeysService){
                    return swifOpenbaseKeysService.resolveData('openresa');
                }
            }
        });
    }

    function ReservationKeysController($scope, data, swifFrameworkService, swifOpenbaseKeysService, swifOpenbaseKeyMovesService) {
        'ngInject';
        var $ctrl = this;
        var swif = swifFrameworkService;
        var service = swifOpenbaseKeysService;
        var moveService = swifOpenbaseKeyMovesService;

        $ctrl.keys = data;
        $ctrl.preModal = preModal;
        $ctrl.preValidate = service.preValidate;
        $ctrl.movePreValidate = moveService.preValidate;
        $ctrl.callback = service.callback;
        $ctrl.moveCallback = moveCallback;

        // Display reservations column
        $ctrl.showResaColumn = true;

        function preModal(data) {
            if (data.action.id === 'add') {
                data.model._type = 'site';
            } else if (data.action.id === 'edit') {
                    data.model._type = 'site';
                if (data.model.storage_equipment) {
                    data.model._storageType = 'equipment';
                }
            } else if (data.action.id === 'move_key') {
                var newModel = {};
                newModel.key_id = [data.model.id];
                newModel.date = moment(new Date()).utc().format('YYYY-MM-DD HH:mm');
                data.model.state === 'available' ? newModel.type = 'checkin' : newModel.type = 'checkout';
                if (data.model.state === 'entrusted') {
                    newModel.holder_contact = data.model.holder_contact;
                    newModel.people_name = data.model.people_name;
                    newModel.people_phone = data.model.people_phone;
                }
                // Clear old model to set move informations
                data.model = newModel;
            }
        }

        function moveCallback(error, data) {
            // Update key state
            service.getCollection().getItems();

            // Add new line to key moves
            return moveService.callback(error, data);
        }
    }
})();
